export default __webpack_public_path__ + "static/media/bg.50ce971d.jpg";